import MasterApi from '../MasterApi';

export default class ConfigTank extends MasterApi {
  constructor() {
    super();
    this.masterName = 'config_tank';
  }
}
